import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Collection} from '../../models/collection.model';
import {Product} from '../../models/product.model';



@Injectable()

export class CollectionService {

  collections: Collection[];
  highlighted: Product[];
  pain: Product[];
  recommended: Product[];

  collectionObserver: BehaviorSubject<Collection[]> = new BehaviorSubject([]);
  recommendedObserver: BehaviorSubject<any[]> = new BehaviorSubject([]);

  constructor(
  ) {
    this.collectionObserver.subscribe((collections: Collection[]) => {
      this.collections = collections;
      const highlightedCollections = this.collections.filter( c => c.title.toLowerCase() === 'highlighted' );
      if ( highlightedCollections && highlightedCollections.length ) {
        this.highlighted = highlightedCollections[0].products;
      }

      const painCollections = this.collections.filter( c => c.title.toLowerCase() === 'pain management' );
      if ( painCollections && painCollections.length ) {
        this.pain = painCollections[0].products;
      }
    });

    this.recommendedObserver.subscribe((products: any[]) => {
      // console.log("Subscribed to recommended observer");
    });

  }
}


